// API設定 - client.tsと同じロジックを使用
const getApiBaseUrl = (): string => {
  if (import.meta.env.VITE_API_URL && !import.meta.env.VITE_API_URL.includes('localhost')) {
    return import.meta.env.VITE_API_URL;
  }
  
  const currentHost = window.location.host;
  const protocol = window.location.protocol;
  
  if (currentHost === 'evaloid.com') {
    return `${protocol}//${currentHost}`;
  } else if (currentHost.includes('localhost') || currentHost.includes('127.0.0.1')) {
    return 'http://localhost:8080';
  } else {
    return `https://${currentHost}`;
  }
};

const API_BASE_URL = getApiBaseUrl();

export interface PDFGenerateRequest {
  examinationId: string;
  productIds?: string[];
}

export interface ReportData {
  examination: any;
  rubric: any;
  products: Array<{
    product: any;
    evaluations: any[];
    overallGrade: string;
  }>;
}

// Generate PDF on the backend
export const generatePDF = async (request: PDFGenerateRequest): Promise<Blob> => {
  const response = await fetch(`${API_BASE_URL}/api/pdf/generate`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
    credentials: 'include', // Include cookies for authentication
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'PDF generation failed');
  }

  return await response.blob();
};

// Get examination report data
export const getExaminationReportData = async (examinationId: string): Promise<ReportData> => {
  const response = await fetch(`${API_BASE_URL}/api/examinations/${examinationId}/report-data`, {
    method: 'GET',
    credentials: 'include', // Include cookies for authentication
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to fetch report data');
  }

  return await response.json();
};

// Download PDF
export const downloadPDF = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};